// OpenTelemetry Browser Instrumentation for Public Display
import { WebTracerProvider } from '@opentelemetry/sdk-trace-web';
import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http';
import { registerInstrumentations } from '@opentelemetry/instrumentation';
import { DocumentLoadInstrumentation } from '@opentelemetry/instrumentation-document-load';
import { UserInteractionInstrumentation } from '@opentelemetry/instrumentation-user-interaction';
import { XMLHttpRequestInstrumentation } from '@opentelemetry/instrumentation-xml-http-request';
import { FetchInstrumentation } from '@opentelemetry/instrumentation-fetch';

// Initialize OpenTelemetry for Public Display
export const initializeOpenTelemetry = () => {
  // Disable OpenTelemetry in development to avoid CORS errors
  // Enable in production when OpenTelemetry collector is properly configured
  if (import.meta.env.VITE_ENABLE_OTEL !== 'true') {
    console.log('OpenTelemetry disabled in development mode');
    return;
  }

  try {
    // Configure OTLP exporter to send traces to the OpenTelemetry Collector
    const exporter = new OTLPTraceExporter({
      url: import.meta.env.VITE_OTEL_ENDPOINT || 'http://localhost:4318/v1/traces',
    });

    // Initialize WebTracerProvider with the span processor. Newer @opentelemetry
    // SDKs take spanProcessors in the constructor; the addSpanProcessor() method
    // was removed.
    const provider = new WebTracerProvider({
      spanProcessors: [
        {
          onStart: () => {},
          onEnd: (span: any) => {
            exporter.export([span], (result: any) => {
              if (result.error) {
                console.error('OpenTelemetry export error:', result.error);
              }
            });
          },
          forceFlush: () => Promise.resolve(),
          shutdown: () => Promise.resolve(),
        },
      ],
    });

    // Register the provider
    provider.register();

    // Register instrumentations
    registerInstrumentations({
      instrumentations: [
        new DocumentLoadInstrumentation(),
        new UserInteractionInstrumentation({
          eventNames: ['click', 'submit', 'input', 'change', 'focus', 'blur'],
        }),
        new XMLHttpRequestInstrumentation(),
        new FetchInstrumentation(),
      ],
    });

    console.log('OpenTelemetry browser instrumentation initialized for Public Display');
  } catch (error) {
    console.error('Failed to initialize OpenTelemetry:', error);
  }
};